// extracted by mini-css-extract-plugin
export default {"root":"FilterComponent_root__WPqaz","input":"FilterComponent_input__FMXnP","icon":"FilterComponent_icon__Y8fB4"};